import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AllEventsFragmentFragmentDoc } from '../fragments/allEventsFragement.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllEventsPaginatedQueryVariables = Types.Exact<{
  filter: Types.EventsFilterInput;
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type AllEventsPaginatedQuery = { __typename?: 'Query', eventsPaginated: { __typename?: 'EventPaginatedResult', total: number, events: Array<{ __typename?: 'Event', id: string, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, event_participants?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_id?: string | null }> | null }> }> | null }> } };


export const AllEventsPaginatedDocument = gql`
    query allEventsPaginated($filter: EventsFilterInput!, $skip: Int!, $take: Int!) {
  eventsPaginated(filter: $filter, skip: $skip, take: $take) {
    total
    events {
      ...allEventsFragment
    }
  }
}
    ${AllEventsFragmentFragmentDoc}`;

/**
 * __useAllEventsPaginatedQuery__
 *
 * To run a query within a React component, call `useAllEventsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEventsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEventsPaginatedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAllEventsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<AllEventsPaginatedQuery, AllEventsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEventsPaginatedQuery, AllEventsPaginatedQueryVariables>(AllEventsPaginatedDocument, options);
      }
export function useAllEventsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEventsPaginatedQuery, AllEventsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEventsPaginatedQuery, AllEventsPaginatedQueryVariables>(AllEventsPaginatedDocument, options);
        }
export type AllEventsPaginatedQueryHookResult = ReturnType<typeof useAllEventsPaginatedQuery>;
export type AllEventsPaginatedLazyQueryHookResult = ReturnType<typeof useAllEventsPaginatedLazyQuery>;
export type AllEventsPaginatedQueryResult = Apollo.QueryResult<AllEventsPaginatedQuery, AllEventsPaginatedQueryVariables>;